import React from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"

import {
	Row,
	Col,
	CustomInput,
	Form,
	FormGroup,
	FormText,
	Input,
	InputGroup,
	InputGroupAddon,
	UncontrolledModal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Avatar,
} from "../../../../components"

import * as ACTIONS from "../../../../store/actions"
import * as clearview from "../../../../components/@Clearview"

class AddUser_Form extends React.Component {
	static propTypes = {
		business: PropTypes.object.isRequired,
		groupName: PropTypes.string.isRequired,
		isInHouse: PropTypes.bool.isRequired,
		doAction: PropTypes.func.isRequired,
	}

	constructor(props) {
		super(props)

		if (props.business) {
			this.state = {
				customer: clearview.CustomerFor(props.business),
				client: props.isInHouse ? clearview.CustomerFor(props.business) : clearview.ClientFor(props.business),
				role: "Member",
				messageOption: "bcc",
			}
		} else this.state = {}

		this.handleActionButtonClick = this.handleActionButtonClick.bind(this)
		this.handleChange = this.handleChange.bind(this)
		this.isPropertyRequired = this.isPropertyRequired.bind(this)
	}

	handleActionButtonClick(e) {
		clearview.StopPropagation(e)

		if (!this.isValid) {
			this.setState({ showValidation: true })
			return
		}

		this.props.doAction(this.state.customer, {
			email: this.state.email,
			name: this.state.name,
			username: this.state.username,
			initials: this.state.initials,
			roleName: this.state.role,

			businessReference: this.state.client.reference,

			messageTo: this.state.messageOption == "self" ? "self" : this.state.email,
			messageBcc: this.state.messageOption == "bcc" ? "self" : undefined,

			memberships: { [this.props.business.reference]: [this.props.groupName, this.state.role] },
		})
		return true
	}

	handleChange(e) {
		const newState = {
			[e.target.name]: e.target.value,
		}

		switch (e.target.name) {
			case "email":
				const suggestedName = clearview.EmailToName(e.target.value)
				if (!this.state.name || clearview.ExtendsString(suggestedName, this.state.name, true))
					this.setState(newState, _ => this.handleChange({ target: { name: "name", value: suggestedName } }))
				else this.setState(newState)
				break

			case "name":
				const suggestedUsername = clearview.NameToUsername(e.target.value)
				if (!this.state.username || clearview.ExtendsString(suggestedUsername, this.state.username, true)) newState.username = suggestedUsername

				const suggestedInitials = clearview.NameToInitials(e.target.value)
				if (!this.state.initials || clearview.ExtendsString(suggestedInitials, this.state.suggestedInitials, true))
					newState.initials = suggestedInitials

				this.setState(newState)
				break

			default:
				this.setState(newState)
		}
	}

	isPropertyRequired(propertyName) {
		if (this.state[propertyName] === undefined || !this.state[propertyName]?.length) return true

		if (propertyName === "email" && !clearview.ValidEmail(this.state.email)) return true
		return false
	}

	isPropertyValid(propertyName) {
		switch (propertyName) {
			case "email":
				return clearview.ValidEmail(this.state.email)

			default:
				return false
		}
	}

	get isValid() {
		return (
			!this.isPropertyRequired("email") &&
			!this.isPropertyRequired("name") &&
			!this.isPropertyRequired("username") &&
			!this.isExistingUsername(this.state.username) &&
			!this.isPropertyRequired("initials")
		)
	}

	isExistingUsername(username) {
		const lowerUsername = username.toLowerCase()
		const cust = clearview.CustomerFor(this.props.business)
		const existingUser = ACTIONS.findInBranch(
			cust,
			client => client.teams?.find(it => it.type === "Users")?.users.find(u => u.username.toLowerCase() === lowerUsername),
			client => client.children
		)

		return !!existingUser
	}

	render() {
		const { business, groupName, isInHouse } = this.props

		return (
			<UncontrolledModal style={{ maxWidth: 650 }} target={`AddUser_Form_${business.id}-${groupName}-${isInHouse}`}>
				<Form onSubmit={this.handleSubmit}>
					<ModalHeader tag="div">
						<div className="d-flex">
							<Avatar.Font size="lg" bgColor={isInHouse ? "blue" : "green"} className="avatar-with-text mr-1">
								{clearview.Icon.Business.AddUser}
							</Avatar.Font>
							<h6>
								{" "}
								Create New <b>{this.state.client.name}</b> user
								{this.state.client.name !== business.name && (
									<span>
										<br />
										Restricted to <b>{business.name}</b>
									</span>
								)}
								{groupName && (
									<span>
										<br />
										In the <b className="nowrap">{groupName}</b> team
									</span>
								)}
								{!groupName && this.state.role !== "Admin" && (
									<span>
										<br />
										<b className="nowrap">To be assigned to Properties later!</b>
									</span>
								)}
							</h6>
						</div>
					</ModalHeader>

					<ModalBody>
						<Row className="mb-0">
							<Col lg={12}>
								<FormGroup row>
									<InputGroup>
										<InputGroupAddon addonType="prepend">Email:</InputGroupAddon>
										<Input
											invalid={this.state.showValidation && this.isPropertyRequired("email")}
											type="text"
											name="email"
											id="email"
											placeholder="Email..."
											value={this.state.email}
											onChange={this.handleChange}
										/>
									</InputGroup>
									<FormText hidden={!this.state.showValidation || !this.isPropertyRequired("email")} className="text-danger">
										Email must be a valid email
									</FormText>
								</FormGroup>
							</Col>
						</Row>
						<Row className="mb-0">
							<Col lg={8}>
								<FormGroup row>
									<InputGroup>
										<InputGroupAddon addonType="prepend">Name:</InputGroupAddon>
										<Input
											invalid={this.state.showValidation && this.isPropertyRequired("name")}
											type="text"
											name="name"
											id="name"
											placeholder="Name..."
											value={this.state.name}
											onChange={this.handleChange}
										/>
									</InputGroup>
									<FormText hidden={!this.state.showValidation || !this.isPropertyRequired("name")} className="text-danger">
										Name is required
									</FormText>
								</FormGroup>
								<FormGroup row>
									<InputGroup>
										<InputGroupAddon addonType="prepend">Username:</InputGroupAddon>
										<Input
											invalid={this.state.showValidation && this.isPropertyRequired("username")}
											type="text"
											name="username"
											id="username"
											placeholder="Username..."
											value={this.state.username}
											onChange={this.handleChange}
										/>
									</InputGroup>
									<FormText hidden={!this.state.showValidation || !this.isPropertyRequired("username")} className="text-danger">
										Username is required
									</FormText>
									<FormText hidden={!this.state.showValidation || !this.isExistingUsername(this.state.username)} className="text-danger">
										{this.state.username} is already in use
									</FormText>
								</FormGroup>
								<FormGroup row>
									<InputGroup>
										<InputGroupAddon addonType="prepend">Initials:</InputGroupAddon>
										<Input
											invalid={this.state.showValidation && this.isPropertyRequired("initials")}
											type="text"
											maxLength={4}
											name="initials"
											id="initials"
											placeholder="Initials..."
											value={this.state.initials}
											onChange={this.handleChange}
										/>
									</InputGroup>
									<FormText hidden={!this.state.showValidation || !this.isPropertyRequired("initials")} className="text-danger">
										Initials are required
									</FormText>
								</FormGroup>
							</Col>
							<Col>
								<FormGroup row>
									<InputGroup>
										<InputGroup className="manageUsersRoles">
											<CustomInput
												className="ml-0 mr-0 mt-2 mb-2"
												type="radio"
												label="Reader"
												id="Reader"
												name="role"
												inline
												value="Reader"
												defaultChecked={this.state.role === "Reader"}
												onChange={this.handleChange}
											/>
											<br />
											<CustomInput
												className="ml-0 mr-0 mt-2 mb-2"
												type="radio"
												id="Member"
												label="Member"
												name="role"
												inline
												value="Member"
												defaultChecked={this.state.role === "Member"}
												onChange={this.handleChange}
											/>
											<br />
											<CustomInput
												className="ml-0 mr-0 mt-2 mb-2"
												type="radio"
												label="Approver"
												id="Approver"
												name="role"
												inline
												value="Approver"
												defaultChecked={this.state.role === "Approver"}
												onChange={this.handleChange}
											/>
											<br />
											<CustomInput
												className="ml-0 mr-0 mt-2 mb-2"
												type="radio"
												id="Admin"
												label="Admin"
												name="role"
												inline
												value="Admin"
												defaultChecked={this.state.role === "Admin"}
												onChange={this.handleChange}
											/>
										</InputGroup>
									</InputGroup>
								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col lg={12}>
								<FormGroup row>
									<InputGroup>
										<CustomInput
											className="ml-0 mr-0 mt-2 mb-2 full-width"
											type="radio"
											label="Email password to new user and BCC me"
											id="messageOptionBcc"
											name="messageOption"
											value="bcc"
											defaultChecked={this.state.messageOption === "bcc"}
											onChange={this.handleChange}
										/>
										<CustomInput
											className="ml-0 mr-0 mt-2 mb-2 full-width"
											type="radio"
											label="Email password to me only"
											id="messageOptionSelf"
											name="messageOption"
											value="self"
											defaultChecked={this.state.messageOption === "self"}
											onChange={this.handleChange}
										/>
										<CustomInput
											className="ml-0 mr-0 mt-2 mb-2 full-width"
											type="radio"
											label="Email password to new user only"
											id="messageOptionUser"
											name="messageOption"
											value="user"
											defaultChecked={this.state.messageOption === "user"}
											onChange={this.handleChange}
										/>
									</InputGroup>
								</FormGroup>
							</Col>
						</Row>
					</ModalBody>

					<ModalFooter>
						<UncontrolledModal.Cancel color="link" className="text-primary">
							Cancel
						</UncontrolledModal.Cancel>
						<UncontrolledModal.Close color="default" className="text-primary" onClick={this.handleActionButtonClick}>
							Save
						</UncontrolledModal.Close>
					</ModalFooter>
				</Form>
			</UncontrolledModal>
		)
	}
}

const mapDispatchToProps = dispatch => ({
	doAction: (customer, params) =>
		dispatch({
			type: ACTIONS.WORKFLOW_CREATE_USER,
			customer: customer,
			params: params,
		}),
})

export default connect(null, mapDispatchToProps)(AddUser_Form)
